<template>
    <div class="team main_width main_color m_0">
        <div class="team_title">团队风采</div>
        <swiper :options="swiperOption" ref="mySwiper" >
            <swiper-slide>
                <img src="/static/images2/about_team1.webp" alt="">
            </swiper-slide>
            <swiper-slide>
                <img src="/static/images2/about_team2.webp" alt="">
            </swiper-slide>
            <swiper-slide>
                <img src="/static/images2/about_team3.webp" alt="">
            </swiper-slide>
            <swiper-slide>
                <img src="/static/images2/about_team4.jpg" alt="">
            </swiper-slide>
             <div class="swiper-pagination" slot="pagination"></div>
        </swiper>
    </div>
</template>
<script>
import 'swiper/dist/css/swiper.css'
import { swiper, swiperSlide } from 'vue-awesome-swiper'
export default {
  name: "team",
    components: {
        swiper,
        swiperSlide
    },
    data() {
        return {
            swiperOption: {
                name: "mySwiper",
                paginationClickable: true,
                preloadImages: false,
                loop: true,
                autoplay: {
                    delay: 3000,
                    stopOnLastSlide: false,
                    disableOnInteraction: false
                },
                pagination: {
                    el: ".swiper-pagination",
                    clickable: true
                },
                autoplayDisableOnInteraction: false,
                observeParents: true,
                observer: true,
            }
        }
    }
}
</script>
<style lang="less" scoped>
@import "../../assets/style/utils.less";
.team {
    margin-top: .px2vw(96)[@result];
    margin-bottom: .px2vw(120)[@result];
    .team_title {
        text-align: center;
        font-weight: 700;
        font-size: .px2vw(32)[@result];
        margin-bottom: .px2vw(32)[@result];
    }
    .swiper-slide {
        text-align: center;
        img {
            width: .px2vw(1200)[@result];
            height: .px2vw(560)[@result];
            object-fit: cover;
        }
    }
}
@media screen and (max-width: 900px) {
    .team {
        margin: 0;
        padding: .h5px2vw(48)[@result] .h5px2vw(32)[@result];
        .team_title {
            font-size: .h5px2vw(32)[@result];
            margin-bottom: .h5px2vw(24)[@result];
        }
        .swiper-slide {
            img {
                width: 100%;
                height: .h5px2vw(320)[@result];
            }
        }
    }
}
</style>
<style lang="less">
@import "../../assets/style/utils.less";
    .swiper-pagination > .swiper-pagination-bullet {
        width: .px2vw(8)[@result];
        height: .px2vw(8)[@result];
        background: rgba(255,255,255,0.6);
        border-radius: .px2vw(4)[@result];
        opacity: 0.6;
    }
    .swiper-pagination > .swiper-pagination-bullet-active {
        width: .px2vw(23)[@result];
        height: .px2vw(8)[@result];
        background: rgba(255,255,255,0.8);
        border-radius: .px2vw(4)[@result];
    }
@media screen and (max-width: 900px) {
    .swiper-pagination > .swiper-pagination-bullet {
        width: .h5px2vw(8)[@result];
        height: .h5px2vw(8)[@result];
        border-radius: .h5px2vw(4)[@result];
    }
    .swiper-pagination > .swiper-pagination-bullet-active {
        width: .h5px2vw(23)[@result];
        height: .h5px2vw(8)[@result];
        border-radius: .h5px2vw(4)[@result];
    }
}
</style>


// WEBPACK FOOTER //
// src/pages/about/team.vue